import { FunctionComponent, PropsWithChildren } from 'react';

export const TabBar: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <div className="h-stack items-center space-x-0.5">{children}</div>;
};
